import { fulfilled, pending, rejected } from '../../../utils';
import { CONFIRM_ACCOUNT } from '../../actions/actiontype';

const initialState = {
	status: '',
	loading: false,
	message: '',
	data: '',
	error: '',
};

const confirmAccountReducer = (state = initialState, action) => {
	switch (action.type) {
		case pending(CONFIRM_ACCOUNT):
			return {
				...state,
				loading: true,
				message: '',
				error: '',
			};
		case fulfilled(CONFIRM_ACCOUNT):
			return {
				...state,
				loading: false,
				status: action.payload.data.status,
				message: action.payload.data.message,
				data: action.payload.data.data,
				error: '',
			};
		case rejected(CONFIRM_ACCOUNT):
			return {
				...state,
				loading: false,
				status: action.payload.response.data.status,
				message: '',
				error: action.payload.response.data.message,
			};
		default:
			return state;
	}
};

export default confirmAccountReducer;
